// src/pages/DashboardPage/DashboardPage.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import ExcursionsTab from "features/excursions/ExcursionsTab";
import ChalesTab from "features/chales/ChalesTab";
import { useUser } from "hooks/useUser";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";

function DashboardPage() {
  const { role, canViewExcursions, canViewChales, canViewEstoque, canViewDashboard } = useUser();
  const [searchTerm, setSearchTerm] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setSearchTerm(inputValue);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [inputValue]);

  // Se o usuário não tem acesso às duas abas principais de reserva da Home:
  if (!canViewExcursions && !canViewChales) {
      if (canViewEstoque) return <Navigate to="/estoque" replace />;
      if (canViewDashboard) return <Navigate to="/dashboard" replace />;
      if (role === "admin") return <Navigate to="/admin" replace />;
      
      // Fallback amigável caso seja um usuário sem nenhuma permissão de visualização restando
      return (
        <div className="flex flex-col items-center justify-center h-[60vh] text-center px-4">
          <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-200">Bem-vindo ao Gestão Timbó</h2>
          <p className="mt-4 text-slate-600 dark:text-slate-400 max-w-md">
            Você não possui permissões ativas para visualizar os recursos do sistema. 
            Por favor, solicite acesso a um administrador.
          </p>
        </div>
      );
  }

  const defaultTab = canViewExcursions
    ? "excursions"
    : "chales";

  return (
    <div className="w-full max-w-7xl mx-auto px-2 sm:px-4" userRole={role}>
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Buscar por telefone..."
            className="border p-2 rounded w-64 text-black dark:text-white dark:bg-gray-800 border-gray-300 dark:border-gray-600"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </div>
      </div>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList>
          {canViewExcursions && (
            <TabsTrigger value="excursions">Excursões</TabsTrigger>
          )}

          {canViewChales && <TabsTrigger value="chales">Chalés</TabsTrigger>}
        </TabsList>

        {canViewExcursions && (
          <TabsContent value="excursions" className="mt-6">
            <ExcursionsTab userRole={role} searchTerm={searchTerm} />
          </TabsContent>
        )}

        {canViewChales && (
          <TabsContent value="chales" className="mt-6">
            <ChalesTab userRole={role} searchTerm={searchTerm} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}

export default DashboardPage;
